module.exports = __webpack_public_path__ + "static/LoadPath_Comparison-e1c3d0f6353ed9b64e24ba016b7e9ed3.png";